import { ClientItemId } from 'owa-client-ids';
import getBasePath from 'owa-url/lib/getBasePath';
import { getHostLocation } from 'owa-url/lib/hostLocation';

const DEEPLINK_URL =
    '/' +
    [
        'mail',
        ...getBasePath()
            .split('/')
            .slice(1),
    ].join('/') +
    'deeplink/saveAndEdit/';

export function openNewTabAndSave(
    attachmentId: string,
    subscriptionId: string,
    parentItemId?: ClientItemId
) {
    let url: string = `${DEEPLINK_URL}`;

    url += `${encodeURIComponent(parentItemId?.Id)}/${encodeURIComponent(
        attachmentId
    )}/${encodeURIComponent(subscriptionId)}/${getHostLocation().search}`;
    window.open(url, '_blank');
}
